import * as DataTableDAO from 'notebook/data-tables/DataTableDAO';
import {Cell} from 'notebook/tables/constants/CellConstants';
import {FIELD_TYPES} from 'schemas/fields/SchemaFieldConstants';
import * as ImportUtil from 'util/ImportUtil';
import {withLoadingScreen} from 'util/Promises';

export default async function convertFileToCellData(
  file: File
): Promise<{text: string; cellData: Partial<Cell>}> {
  const deferred = ImportUtil.upload(file)
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    .then((s3Location: any) => DataTableDAO.createBlobs([s3Location], {shouldGeneratePreviewFile: true}))
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    .then((blobs: Array<any>) => blobs[0]);
  const blob = await withLoadingScreen(Promise.resolve(deferred), 'Uploading...');
  return {
    text: blob.name,
    cellData: {
      typedValue: {
        type: FIELD_TYPES.BLOB_LINK.type as 'ft_blob_link',
        value: null,
        targetBlobs: [blob],
      },
    },
  };
}
